import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateProduct } from "../../Redux/Slices/Products/productsAction";
import { useParams } from "react-router-dom";
import axios from "axios";

function EditProduct() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { products } = useSelector((state) => state);

  const [productData, setProductData] = useState({
    name: "",
    image: "",
    disponible: "",
    price: "",
    subCategory: "",
    description: "",
  });

  useEffect(() => {
    axios
      .get(`/products/${id}`)
      .then((res) => {
        console.log("Data from API:", res.data);
        setProductData(res.data);
      })
      .catch((e) => console.log(e));
  }, [id]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const trimmedData = {
      id: id,
    };

    for (const key in productData) {
      if (typeof productData[key] === "string") {
        trimmedData[key] = productData[key].trim();
      } else {
        trimmedData[key] = productData[key];
      }
    }

    console.log("Updated product data:", trimmedData);

    axios
      .put(`/products/${id}`, trimmedData)
      .then((res) => {
        dispatch(updateProduct(trimmedData));
        window.location.replace("/");
      })
      .catch((e) => console.log(e));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setProductData({
      ...productData,
      [name]: value,
    });
  };

  return (
    <form
      class=" min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12"
      onSubmit={handleSubmit}
    >
      <h1 class="text-2xl font-semibold text-red-900">Editar Producto</h1>

      <input
        type="text"
        value={productData.name}
        onChange={handleInputChange}
        name="name"
        placeholder="Nombre"
        class="h-10 w-full border-b-2 border-gray-300 rounded-lg border-2"
      />
      <input
        type="text"
        value={productData.price}
        onChange={handleInputChange}
        name="price"
        placeholder="Precio"
        class="h-10 w-full border-b-2 border-gray-300 rounded-lg border-2"
      />

      <input
        type="text"
        value={productData.image}
        placeholder="Imagen"
        onChange={handleInputChange}
        name="image"
        class="h-10 w-full border-b-2 border-gray-300 rounded-lg border-2"
      />

      <input
        type="text"
        value={productData.disponible}
        placeholder="Disponibilidad"
        onChange={handleInputChange}
        name="disponible"
        class="h-10 w-full border-b-2 border-gray-300 rounded-lg border-2"
      />

      <input
        type="text"
        value={productData.subCategory}
        placeholder="Subcategoria"
        onChange={handleInputChange}
        name="subCategory"
        class="h-10 w-full border-b-2 border-gray-300 rounded-lg border-2"
      />
      <input
        type="text"
        value={productData.description}
        placeholder="Descripcion"
        onChange={handleInputChange}
        name="description"
        class="h-10 w-full border-b-2 border-gray-300 rounded-lg border-2"
      />

      <button
        class="bg-gray-500 text-white rounded-md px-2 py-1"
        type="submit"
        onClick={handleSubmit}
      >
        Guardar cambios
      </button>
    </form>
  );
}

export default EditProduct;